type Fields = Record<string, any>;

export function uiLog(ev: string, fields: Fields = {}) {
  const payload = { ts: Date.now(), ev, ...fields };
  if (import.meta.env.PROD && import.meta.env.VITE_TELEMETRY_URL) {
    try {
      const url = import.meta.env.VITE_TELEMETRY_URL as string;
      navigator.sendBeacon(
        url,
        new Blob([JSON.stringify(payload)], { type: "application/json" })
      );
    } catch {
      console.log(JSON.stringify(payload));
    }
  } else {
    console.log(JSON.stringify(payload));
  }
}

export function uiHash(s: string) {
  let h = 2166136261;
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i);
    h = Math.imul(h, 16777619) >>> 0;
  }
  return h.toString(16);
}
